import { Routes, Route } from 'react-router-dom';
import Home from "../pages/home/home";
import Login from "../pages/login/login";
import Unauthorized from "../pages/unauthorized/unauthorized";
import ProtectedRoute from "./protected-route";
import Financial from "../pages/financial/list/list-financial";
import FinancialEdit from "../pages/financial/edit/edit-financial";
import ProjectAdd from "../pages/project/add/add-project";
import { ListUser } from "../pages/control-painel/user/list";
import { AddClient } from "../pages/control-painel/client/add/add";
import { ListClient } from "../pages/control-painel/client/list/list";
import { EditClient } from "../pages/control-painel/client/edit/edit";
import { ListPlan } from "../pages/control-painel/plans/list/list";
import { AddPlan } from "../pages/control-painel/plans/add/add";
import { EditPlan } from "../pages/control-painel/plans/edit/edit";
import { ListUsers } from "../pages/control-painel/users/list/list";
import { EditUser } from "../pages/control-painel/users/edit/edit";
import { AddUser } from "../pages/control-painel/users/add/add";
import { FirstAcess } from "../pages/first-acess/first-acess";
import ProjectEdit from '../pages/project/edit/edit-project';
import ProjectList from '../pages/project/list/list-project';
import { RecoveryPassword } from '../pages/recovery-password/recoveryPassword';
import FinancialReport from '../pages/reports/financial/financial-report';
import { ListBeneficiary } from '../pages/control-painel/beneficiary/list/list';
import AddBeneficiary from '../pages/control-painel/beneficiary/add/add-beneficiary';
import EditBeneficiary from '../pages/control-painel/beneficiary/edit/edit-beneficiary';
import NotificationCenter from '../pages/notification-center/notification';
import NotificationSettingsPage from '../pages/control-painel/notification-settings/notification-settings';

function RoutesComponent() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/primeiro-acesso" element={<FirstAcess />} />
            <Route path="/primeiro-acesso/:recovery" element={<FirstAcess />} />
            <Route path="/recuperar-senha" element={<RecoveryPassword />} />
            <Route path="/recuperar-senha/:recovery/verificar" element={<RecoveryPassword />} />

            <Route 
                path="/dashboard" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<Home />} />
            </Route>

            <Route 
                path="/projeto" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ProjectAdd />} />
            </Route>

            <Route 
                path="/projeto/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ProjectEdit />} />
            </Route>

            <Route 
                path="/projeto-list/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ProjectList />} />
            </Route>

            <Route 
                path="/financeiro" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<Financial />} />
            </Route>

            <Route 
                path="/financeiro/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<FinancialEdit />} />
            </Route>

            <Route 
                path="/relatorio-financeiro/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<FinancialReport />} />
            </Route>

            <Route 
                path="/financeiro/:id/adicionar-projeto" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<Financial />} />
            </Route>

            <Route 
                path="/meus-dados" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ListUser />} />
            </Route>

            <Route 
                path="/cliente" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<AddClient />} />
            </Route>

            <Route 
                path="/cliente/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<EditClient />} />
            </Route>

            <Route 
                path="/clientes" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ListClient />} />
            </Route>

            <Route 
                path="/plano" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<AddPlan />} />
            </Route>

            <Route 
                path="/plano/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<EditPlan />} />
            </Route>

            <Route 
                path="/planos" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ListPlan />} />
            </Route>

            <Route 
                path="/usuario" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<AddUser />} />
            </Route>

            <Route 
                path="/usuario/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<EditUser />} />
            </Route>

            <Route 
                path="/usuarios" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ListUsers />} />
            </Route>

            <Route 
                path="/beneficiarios" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<ListBeneficiary />} />
            </Route>

            <Route 
                path="/beneficiario" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<AddBeneficiary />} />
            </Route>

            <Route 
                path="/beneficiario/:id" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<EditBeneficiary />} />
            </Route>

            <Route 
                path="/notificacao" 
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<NotificationCenter />} />
            </Route>

            <Route
                path="/configuracao-notificacoes"
                element={<ProtectedRoute allowedRoles={[]} />}
            >
                <Route index element={<NotificationSettingsPage />} />
            </Route>

            {/* Rota 404 - Página não encontrada (opcional) */}
            <Route path="*" element={<Unauthorized />} />
        </Routes>
    );
}

export default RoutesComponent;
